import { Authority } from '@/shared/security/authority';
/* tslint:disable */
// prettier-ignore

// jhipster-needle-add-entity-to-router-import -  Enhouse billing will import entities to the router here

export default [
  // jhipster-needle-add-entity-to-router -  Enhouse billing will add entities to the router here
]
